import React, { FC, useState } from 'react';

import { Button, Card, CardContent, Collapse, Grid, Typography, Box, Divider, Chip } from '@mui/material';

import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import InfoIcon from '@mui/icons-material/Info';

import JobDetailsSlideDown from './JobDetailsSlideDown';

import { BackflowJobItem } from '../../model';

interface SubmissionPdfCardProps {
  item: BackflowJobItem;
}

const SubmissionPdfCard: FC<SubmissionPdfCardProps> = (props) => {
  const { item } = props;
  const [slideOpen, setSlideOpen] = useState(false);

  const handleView = () => {
    if (item.water_authority_submission_pdf_url) {
      window.open(item.water_authority_submission_pdf_url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <Card elevation={2} sx={{ height: '100%' }}>
      <CardContent>
        <Grid container>
          <Grid item xs={12}>
            <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={2}>
              <Typography variant="h6" fontWeight="600" color="primary">
                {item.asset_no}
              </Typography>
              <Chip
                label={item.status}
                color="success"
                size="small"
                sx={{ textTransform: 'uppercase', fontWeight: 600 }}
              />
            </Box>
            <Divider sx={{ my: 2 }} />
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              <strong>Location:</strong>
            </Typography>
            <Typography variant="body1" gutterBottom>
              {item.location || 'N/A'}
            </Typography>

            <Typography variant="body2" color="text.secondary" gutterBottom sx={{ mt: 1 }}>
              <strong>Device Type:</strong>
            </Typography>
            <Typography variant="body1">{item.device_type || 'N/A'}</Typography>
          </Grid>
          <Grid item xs={6} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
            <Button
              variant="contained"
              color="secondary"
              startIcon={<OpenInNewIcon />}
              onClick={handleView}
              disabled={!item.water_authority_submission_pdf_url}
              fullWidth
              size="medium"
              sx={{ width: '60%' }}
            >
              View Report PDF
            </Button>
            <Button
              variant="outlined"
              color="primary"
              startIcon={<InfoIcon />}
              onClick={() => setSlideOpen(true)}
              fullWidth
              size="medium"
              sx={{ width: '60%' }}
            >
              View Job Details
            </Button>
          </Grid>
          <Collapse in={slideOpen} timeout={300} unmountOnExit>
            <Grid item xs={12}>
              <JobDetailsSlideDown item={item} setSlideOpen={setSlideOpen} />
            </Grid>
          </Collapse>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default SubmissionPdfCard;
